<script lang="ts" >
    import type { AdvancementStep } from "./step";
    import StepProgressHorizontal from "./step-progress-horizontal.svelte";
    import StepProgressVertical from "./step-progress-vertical.svelte";

    // Défine if the progress 
    export let mode : "vertical" | "horizontal" = "vertical";

    // List
    export let steps: AdvancementStep[];

    // Selected
    export let selected : number = 1;

    // Updated step
    $: udpatedSteps = updateSteps(selected);

    // Functions
    // -- Update steps
    const updateSteps = (current: number) => {
        return steps.map(c => {
           return { 
                ...c,
                active : c.number == current,
                done : c.number < current
            };
        });
    }

    // Component
    let component = mode === "vertical" ? StepProgressVertical : StepProgressHorizontal;

</script>


<svelte:component this={component} steps={udpatedSteps} />




